var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-select", {
    class: {
      "v-select-danger": _vm.invalid === false,
      "select-size-sm": _vm.small
    },
    attrs: {
      value: _vm.value,
      name: _vm.name,
      options: _vm.filteredOpts,
      disabled: _vm.isDisabled,
      placeholder: _vm.computedPlaceholder,
      loading: _vm.isLoading,
      selectable: function(opt) {
        return !opt.disabled
      },
      reduce: function(opt) {
        return opt.value
      },
      "create-option": function(opt) {
        return { value: opt, label: opt }
      },
      "close-on-select": !_vm.multiple,
      clearable: _vm.clearable,
      taggable: _vm.taggable,
      searchable: _vm.searchable,
      filterable: _vm.filterable,
      multiple: _vm.multiple
    },
    on: { "option:selecting": _vm.handleSelecting, input: _vm.onInput },
    scopedSlots: _vm._u([
      {
        key: "spinner",
        fn: function(ref) {
          var loading = ref.loading
          return [
            loading
              ? _c("b-spinner", { attrs: { variant: "primary", small: "" } })
              : _vm._e()
          ]
        }
      },
      {
        key: "no-options",
        fn: function() {
          return [_vm._v(" No hay opciones para el criterio de búsqueda ")]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }